const Skills = () => {
  const skillsData = [
    {
      title: "Frontend",
      skills: [
        { name: "HTML", icon: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png" },
        { name: "CSS", icon: "https://img.icons8.com/?size=96&id=21278&format=png" },
        { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
        { name: "TypeScript", icon: "https://img.icons8.com/color/512/typescript.png" },
        { name: "Bootstrap", icon: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png" },
        { name: "Tailwind CSS", icon: "https://img.icons8.com/?size=96&id=CIAZz2CYc6Kc&format=png" },
        { name: "React Js", icon: "https://img.icons8.com/?size=160&id=asWSSTBrDlTW&format=png" },
        { name: "Next Js", icon: "https://img.icons8.com/fluent-systems-filled/512/FFFFFF/nextjs.png" },
        { name: "Vue Js", icon: "https://img.icons8.com/?size=96&id=rY6agKizO9eb&format=png"},
        { name: "Shadcn UI", icon: "https://avatars.githubusercontent.com/u/139895814?s=200&v=4" },
        { name: "Redux", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg" },
        { name: "Material UI", icon: "https://img.icons8.com/color/512/material-ui.png" },
      ],
    },
    {
      title: "Backend",
      skills: [
        { name: "Firebase", icon: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" },
        { name: "MySQL", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg" },
        { name: "PostgreSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
        { name: "MongoDB", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg" },
        { name: "Node Js", icon: "https://img.icons8.com/?size=96&id=hsPbhkOH4FMe&format=png" },
        { name: "Express Js", icon: "https://img.icons8.com/?size=100&id=kg46nzoJrmTR&format=png" },
        { name: "Supabase", icon: "https://img.icons8.com/?size=96&id=grZaE9tjqDyr&format=png" },
        { name: "TypeScript", icon: "https://img.icons8.com/color/512/typescript.png" },
        { name: "REST API", icon: "https://img.icons8.com/color/512/api.png" },
        { name: "JWT Auth", icon: "https://cdn.worldvectorlogo.com/logos/jwt.svg" },
        { name: "Drizzle ORM", icon: "https://avatars.githubusercontent.com/u/108468352?s=200&v=4" },
      ],
    },
    {
      title: "UI/UX and Programming Langauges",
      skills: [
        { name: "Figma", icon: "https://img.icons8.com/?size=100&id=W0YEwBDDfTeu&format=png&color=000000" },
        { name: "Adobe XD", icon: "https://img.icons8.com/?size=100&id=4VVL78edhbW9&format=png&color=000000" },
        { name: "Zeplin", icon: "https://cdn.sanity.io/images/wd3e2pma/production/7b336dc26fd85ae98b414761d58238d225876a88-60x48.svg" },
        { name: "InVision", icon: "https://img.icons8.com/?size=100&id=cRGU9_-pgw3i&format=png&color=ffffff" },
        { name: "Bubble", icon: "https://fiverr-res.cloudinary.com/images/t_main1,q_auto,f_auto/gigs/209915741/original/078aad966dd5a696f585485c46c0b7f3c20bbed3/develop-a-web-application-using-bubble.jpg" },
        { name: "Webflow", icon: "https://img.icons8.com/?size=100&id=ktrJ12qa5f65&format=png&color=000000" },
        { name: "Sketch", icon: "https://img.icons8.com/?size=100&id=37iEIiYKRoDs&format=png&color=000000" },
      ],
    },
    {
      title: "Tools",
      skills: [
        { name: "Git", icon: "https://img.icons8.com/?size=100&id=20906&format=png&color=000000" },
        { name: "GitHub", icon: "https://img.icons8.com/?size=100&id=12599&format=png&color=ffffff" },
        { name: "VS Code", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" },
        { name: "Postman", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg" },
        { name: "Docker", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
        { name: "GitHub Copilot", icon: "https://github.githubassets.com/images/modules/site/copilot/copilot.png" },
        { name: "Cursor AI", icon: "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/cursor.png" },
        { name: "ChatGPT", icon: "https://img.icons8.com/color/512/chatgpt.png" },
        { name: "DeepSeek", icon: "https://unpkg.com/@lobehub/icons-static-png@latest/light/deepseek.png" },
        { name: "Ollama", icon: "https://unpkg.com/@lobehub/icons-static-png@latest/dark/ollama.png" },
        { name: "Netlify", icon: "https://img.icons8.com/?size=160&id=sBo1RJ3rjbje&format=png" },
        { name: "Vercel", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vercel/vercel-original.svg" },
        { name: "Hostinger", icon: "https://cdn.worldvectorlogo.com/logos/hostinger.svg" },
        { name: "Notion", icon: "https://img.icons8.com/?size=128&id=uVERmCBZZACL&format=png" },
        { name: "Power BI", icon: "https://img.icons8.com/?size=96&id=Ny0t2MYrJ70p&format=png" },
        { name: "MS Excel", icon: "https://img.icons8.com/?size=96&id=117561&format=png" }
      ]
    },
    {
      title: "Programming Languages",
      skills: [
        { name: "Python", icon: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg" },
        { name: "Java", icon: "https://img.icons8.com/?size=96&id=Pd2x9GWu9ovX&format=png" },
        { name: "C", icon: "https://img.icons8.com/?size=96&id=40670&format=png" },
        { name: "C++", icon: "https://img.icons8.com/?size=96&id=40669&format=png" },
        { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
      ],
    },
  ];

  const grouped = [];
  for (let i = 0; i < skillsData.length; i += 2) {
    grouped.push(skillsData.slice(i, i + 2));
  }

  return (
    <section className="min-h-screen bg-bg-secondary px-[9%] py-[10rem] relative" id="skills">
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg
          className="relative block w-[calc(128%+1.3px)] h-[89px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" className="fill-bg-primary"></path>
        </svg>
      </div>

      <div className="relative z-10">
        <div className="flex flex-col items-center">
          <h2 className="text-[32px] md:text-[42px] text-center font-semibold text-white font-rowdies">Skills</h2>
          <p className="text-[16px] md:text-[18px] text-center max-w-[600px] text-white mb-12">
            Over the period of my last three-year B-Tech program, I have acquired a diverse set of skills, and I
            continue to actively enhance my skill set.
          </p>

          <div className="w-full max-w-[1200px] px-4">
            {grouped.map((group, index) => (
              <div
                key={index}
                className={`mb-10 grid ${
                  group.length === 1 ? "grid-cols-1 justify-items-center" : "grid-cols-1 md:grid-cols-2 gap-8"
                }`}
              >
                {group.map((category, idx) => (
                  <div
                    key={idx}
                    className="border border-white shadow-[rgba(23,92,230,0.15)_0px_24px_44px] rounded-2xl p-[24px] bg-bg-secondary/50 w-full max-w-[560px]"
                  >
                    <h3 className="text-[24px] md:text-[28px] font-semibold text-white mb-6 text-center">
                      {category.title}
                    </h3>
                    <div className="flex justify-center flex-wrap gap-3 sm:gap-4">
                      {category.skills.map((skill, skillIndex) => (
                        <div
                          key={skillIndex}
                          className="border border-white rounded-2xl px-4 py-3 flex items-center gap-2 bg-bg-primary/30 whitespace-nowrap"
                        >
                          <img src={skill.icon} alt={skill.name} className="w-6 h-6" />
                          <span className="text-[14px] md:text-[16px] font-medium text-white">{skill.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
